/**
 * @generated SignedSource<<c5ca11060b3f01d0eef237e6ba896387>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useGlobalShortcutsDataRelay$data = {
  readonly appSwitcher_availableProductsBySite: {
    readonly __typename: "AppSwitcherAvailableProductsBySite";
    readonly products: ReadonlyArray<{
      readonly __typename: "AppSwitcherSingleUrlProduct";
      readonly productType: string;
      readonly url: string | null;
    } | {
      readonly __typename: "AppSwitcherSiteScopedProduct";
      readonly productType: string;
      readonly sites: ReadonlyArray<{
        readonly siteId: string;
        readonly url: string | null;
      }> | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }> | null;
  } | {
    readonly __typename: "QueryError";
    readonly message: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentType": "useGlobalShortcutsDataRelay";
};
export type useGlobalShortcutsDataRelay$key = {
  readonly " $data"?: useGlobalShortcutsDataRelay$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGlobalShortcutsDataRelay">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v1 = {
  "kind": "ScalarField",
  "name": "productType"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "useGlobalShortcutsDataRelay",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "kind": "LinkedField",
      "name": "appSwitcher_availableProductsBySite",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "LinkedField",
              "name": "products",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/)
                  ],
                  "type": "AppSwitcherSingleUrlProduct"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v1/*: any*/),
                    {
                      "concreteType": "AppSwitcherProductSite",
                      "kind": "LinkedField",
                      "name": "sites",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "siteId"
                        },
                        (v2/*: any*/)
                      ]
                    }
                  ],
                  "type": "AppSwitcherSiteScopedProduct"
                }
              ]
            }
          ],
          "type": "AppSwitcherAvailableProductsBySite"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "message"
            }
          ],
          "type": "QueryError"
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "c8b29534eaae104f3d284f0f36fda276";

export default node;
